import React from 'react';
import AppApiClient from 'src/app/AppApiClient.js';

import { BackofficeProviderProps as BackofficeApiClientProviderProps } from '@spazious/react-backoffice';

import AppAuthGuardProvider from './AppAuthGuardProvider.js';
import AppStoreProvider, { AppStoreProviderProps } from './AppStoreProvider.js';
import SentryContextSync from './SentryContextSync.js';

export type AppProviderProps = {
  children?: React.ReactNode;
  reduxStore: AppStoreProviderProps['reduxStore'];
  apiClient: BackofficeApiClientProviderProps['client'];
};

/**
 * All the providers of the application.
 */
export const AppProvider: React.FC<AppProviderProps> = ({ reduxStore, children }) => {
  return (
    <AppStoreProvider reduxStore={reduxStore}>
      <AppAuthGuardProvider>
        {/* <BackofficeApiClientProvider client={apiClient}>{children}</BackofficeApiClientProvider> */}
        <AppApiClient>
          <SentryContextSync />
          {children}
        </AppApiClient>
      </AppAuthGuardProvider>
    </AppStoreProvider>
  );
};

export default AppProvider;
